var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 62,
    viewBox: "0 0 64 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1317_4926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1395 12.9121H19.3488C17.8604 12.9121 16.3721 14.3468 16.3721 15.7815V35.8671C16.3721 37.4452 17.7116 38.7365 19.3488 38.7365H46.1395C47.6279 38.7365 49.1163 37.3018 49.1163 35.8671V15.7815C49.1163 14.3468 47.6279 12.9121 46.1395 12.9121ZM22.3256 32.9977L27.5349 26.5416L31.2558 30.86L36.4651 24.3896L43.1628 32.9977H22.3256Z",
    fill: "#54C9BB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8311 36.1346L22.2718 30.9517C22.8034 29.0393 24.845 27.9031 26.829 28.4155C28.813 28.9279 29.9917 30.8959 29.4601 32.8083L28.0194 37.9912C30.071 37.318 31.7345 35.7128 32.3354 33.551C33.2946 30.1003 31.1792 26.5685 27.5994 25.6439C24.0197 24.7193 20.3557 26.7584 19.3965 30.209C18.7956 32.3709 19.4036 34.5628 20.8311 36.1346ZM33.1941 46.2047L27.5377 41.3869C27.3203 41.2268 27.0769 41.1045 26.8038 41.034L25.7111 40.7518L28.0224 32.437C28.3422 31.2868 27.637 30.1095 26.4438 29.8013C25.2505 29.4931 24.0292 30.1728 23.7095 31.323L19.5722 46.2065L14.9184 43.9351C14.8073 43.8915 14.7143 43.8378 14.5849 43.8044C14.1393 43.6893 13.6866 43.7655 13.3221 43.9684L11.8781 44.7837L17.0772 53.4639C17.3613 53.9383 17.8422 54.315 18.4316 54.4672L28.1933 56.9885C29.2715 57.267 30.3173 56.7202 30.7566 55.7494L33.865 48.7247C33.9063 48.6314 33.9476 48.5381 33.9707 48.455C34.2096 47.5958 33.8713 46.7063 33.1941 46.2047V46.2047Z",
    fill: "#00AE9A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1317_4926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.7209,
    height: 34.4325,
    fill: "white",
    transform: "translate(14.8837 8.60815)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningClick);
export default __webpack_public_path__ + "static/media/WarningClick.6f77e881de0c9c2413b69504422130f4.svg";
export { ForwardRef as ReactComponent };